import React, { useContext, useState } from "react";
// components
import AdultsDropdown from "./AdultsDropdown";
import KidsDropdown from "./KidsDropdown";
import { RoomContext } from "../../context/RoomContext";
// import CheckOut from "./CheckOut";
import { useNavigate } from "react-router-dom";
import DateRangePicker from "./DateRangePicker";
import RoomType from "./RoomType";
import { FiSearch } from "react-icons/fi";

const BookForm = ({ onSearchComplete, compact = false }) => {
  const { handleClick, typeRoom, checkInDate, checkOutDate } =
    useContext(RoomContext); // Trae las fechas desde el contexto
  const navigate = useNavigate(); // Hook para navegación
  const [error, setError] = useState(""); // Estado para manejar los errores
  const [searching, setSearching] = useState(false); // Estado de carga al buscar

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validación: Asegurarse de que check-in y check-out estén seleccionados
    if (!checkInDate || !checkOutDate) {
      setError("Por favor, selecciona las fechas de check-in y check-out.");
      return; // Detiene el proceso si faltan fechas
    }

    // Limpiar el error si las fechas están correctas
    setError("");
    setSearching(true);

    try {
      // Llama la función existente
      const results = await handleClick(e);

      // Si hay callback (página de detalle), pasar resultados sin navegar
      if (onSearchComplete) {
        onSearchComplete(results);
        return;
      }

      // Redirige según el tipo de habitación seleccionada
      if (typeRoom === "Hotel") {
        navigate("/hotel"); // Redirige a la ruta deseada
      } else {
        navigate("/glamping"); // Redirige a la ruta deseada
      }
    } finally {
      setSearching(false);
    }
  };

  // Calcula la cantidad de noches entre check-in y check-out
  const calculateNights = () => {
    if (checkInDate && checkOutDate) {
      const timeDiff = checkOutDate - checkInDate;
      return Math.ceil(timeDiff / (1000 * 60 * 60 * 24)); // Retorna el número de noches
    }
    return 0; // Retorna 0 si las fechas no están definidas
  };

  const nights = calculateNights(); // Llama a la función para obtener la cantidad de noches

  return (
    <form className="w-full lg:h-[64px]" onSubmit={handleSubmit}>
      <div className="flex flex-col w-full lg:flex-row lg:h-full">
        <div className="booking-row lg:flex-[1.3]">
          <DateRangePicker />
        </div>
        <div className="booking-row lg:flex-1">
          <AdultsDropdown />
        </div>
        <div className="booking-row lg:flex-1">
          <KidsDropdown />
        </div>
        <div className="booking-row lg:flex-1">
          <RoomType />
        </div>
        {/* btn */}
        <button
          type="submit"
          disabled={searching}
          className="btn btn-primary flex-none h-[52px] mt-5 px-4 whitespace-nowrap disabled:cursor-wait lg:h-auto lg:mt-0 lg:min-w-[190px]"
        >
          {searching ? (
            <span className="flex items-center tracking-normal">
              <span className="mr-2 inline-block h-4 w-4 rounded-full border-2 border-white/40 border-t-white animate-spin" />
              Buscando
            </span>
          ) : (
            <span className="flex items-center">
              <FiSearch className="mr-2" />
              Buscar
            </span>
          )}
        </button>
      </div>

      {/* Mostrar mensaje de error si falta el check-in o check-out */}
      {error && <p className="text-red-500 text-sm mt-3 lg:mt-2">{error}</p>}

      {/* Noches y aclaración (oculto en modo compacto / barra fija de desktop) */}
      <div className={`${compact ? "lg:hidden" : ""} flex flex-col mt-3 text-[11px] text-gray-400 lg:text-sm lg:text-primary lg:mt-2`}>
        {nights > 0 && <p>Cantidad de noches: {nights}</p>}
        <p>*Se considera niño menor entre 2 y 8 años.</p>
      </div>
    </form>
  );
};

export default BookForm;
